var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ui-modal", { on: { hidden: _vm.cancel } }, [
    _c("div", { staticClass: "header" }, [_vm._v(_vm._s(_vm.$t("header")))]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("p", { class: _vm.$style.date }, [_vm._v(_vm._s(_vm.noticeTime))]),
      _vm._v(" "),
      _c("div", {
        staticClass: "body",
        domProps: {
          innerHTML: _vm._s(_vm.$t("body", { closingTime: _vm.closingTime }))
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "actions" }, [
      _c("button", { staticClass: "ui ok button" }, [
        _vm._v(
          "\n      " + _vm._s(_vm._f("cap")(_vm.$t("buttons.close"))) + "\n    "
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }